import axios from "axios";
import Config from "../config";
import RefreshTokenHandler from "../refreshToken/refreshToken";

export const getDistributorByCode = async (email, distributor_code) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/distributor/by-code?email=${email}&distributor_code=${distributor_code}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getDistributorByCode(email, distributor_code);
      } else {
        throw err.response;
      }
    } else {
      throw err.response;
    }
  }
};
